import { useCallback } from 'react';

import { debounce } from 'lodash';
import type { TableState, ActionType } from 'react-table';

import type { TableConfigObjectAdapter } from '../../../stores/alerts-view/table-config-object-adapter';

const ACTION_TYPES = {
	ToggleSortBy: 'toggleSortBy',
	ColumnResizing: 'columnResizing'
};

const useTableStateReducer = <T extends Record<string, unknown>>(tableConfig: TableConfigObjectAdapter) => {
	const { setTableSortBy, setTableColumnWidths } = tableConfig;
	const debouncedSetColumnWidths = useCallback(debounce(setTableColumnWidths, 1000), [setTableColumnWidths]);

	return useCallback(
		(newState: TableState<T>, action: ActionType) => {
			if (action.type === ACTION_TYPES.ToggleSortBy) {
				setTableSortBy(newState.sortBy);
			}
			if (action.type === ACTION_TYPES.ColumnResizing) {
				debouncedSetColumnWidths(newState.columnResizing.columnWidths);
			}

			return newState;
		},
		[setTableSortBy, debouncedSetColumnWidths]
	);
};

export default useTableStateReducer;
